import { getFacilities } from 'actions/facility';
import { getBanner } from 'actions/banner';
import { getPopups } from 'actions/popup';
import { getHotelMeta } from 'actions/hotel.js';

export default store => ({
	path: 'amenities',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container.js').default;
					cb(null, component);
				},
				'Facility',
			),
		onEnter: ({ params: { lang, hotel } }) => {
			store.dispatch(getFacilities(lang, hotel));
			store.dispatch(getBanner(lang, hotel, 'facility'));
			store.dispatch(getPopups(lang, hotel));
			store.dispatch(getHotelMeta(lang, hotel, 'amenities'));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/Facility/index.js